import React from "react";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ThreeDots } from "../../assets/icons";
const MenuDropdown = ({ options }) => {
  const classNames = (...classes) => {
    return classes.filter(Boolean).join(" ");
  };
  return (
    <Menu as="div" className="relative inline-block text-center p-1.5">
      <div>
        <Menu.Button className="flex items-center rounded-full focus:outline-none focus:ring-0">
          <ThreeDots className="h-5 w-5" aria-hidden="true" />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute -right-4 z-[9999] mt-2 w-fit origin-top-right rounded-md bg-white shadow-lg focus:outline-none focus:ring-0 ring-0">
          <div>
            {options?.map((opt, index) => {
              return (
                <Menu.Item key={index}>
                  {({ active }) => (
                    <div
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm rounded-md cursor-pointer truncate"
                      )}
                    >
                      {opt?.label}
                    </div>
                  )}
                </Menu.Item>
              );
            })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default MenuDropdown;
